import { ChevronRight } from 'lucide-react'
import { Link, LinkProps } from 'react-router-dom'

import { Button, ButtonProps } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

interface Props
  extends Pick<LinkProps, 'to'>,
    Omit<ButtonProps, 'children' | 'asChild'> {}

const Component = ({ to, 'aria-label': ariaLabel, ...props }: Props) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button size="icon" asChild aria-label={ariaLabel ?? 'Ir'} {...props}>
          <Link to={to}>
            <ChevronRight className="h-4 w-4" />
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Ir</TooltipContent>
    </Tooltip>
  )
}

export default Component
